export default "__VITE_ASSET__BWqWao9Y__"